<template>
  <div id="app" :class="[$mq, {TA:isTestAchat}]" ref="app">
    <vue-headful :title="$t('appTitle')" :description="$t('appDescription')" :image="$t('appImage')" :url="$t('appUrl')"></vue-headful>
    <div class="banana-background" v-if="$mq === 'desktop'"></div>
    <Header class="header"></Header>
    <Cookies v-if="!cookies" @close="hasCookie()"></Cookies>
    <div class="content">
      <transition enter-active-class="animated bounceInRight">
        <router-view v-if="$route.name"></router-view>
        <div class="loader" v-else>
          <img src="./assets/icons/icon-loader-spin.svg" />
        </div>
      </transition>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Cookies from "@/components/Cookies.vue";
import ProgressionBar from "@/components/ProgressionBar.vue";
import vueHeadful from "vue-headful";
import { mapGetters } from "vuex";

export default {
  name: "App",
  data() {
    return {
      cookies: false,
    };
  },
  computed: {
    ...mapGetters("subscription", ["isTestAchat"])
  },
  methods: {
    hasCookie() {
      if (process.env.NODE_ENV !== 'production'){
        this.cookies = true;
        return;
      }
      this.cookies = this.$cookies.isKey('megacookie');
    },
    setTheme() {
      if(this.isTestAchat) {
        //this.$store.dispatch("theme/setThemeTA");
        this.$refs.app.style.fontFamily = "Lato";
        //document.body.style.background = 'unset';
        //document.body.style.backgroundColor = '#E6EEF0';

      } else {
       // this.$store.dispatch("theme/setThemeMega");
      }
    }
  },
  created() {
    this.$store.dispatch("common/getLegalForms");
    this.hasCookie();
  },
  mounted(){
    this.setTheme();
  },
  components: {
    Header,
    Footer,
    Cookies,
    ProgressionBar,
    vueHeadful
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: ObjectSans;
  src: url("./assets/fonts/ObjectSans-Regular.otf");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: ObjectSans;
  src: url("./assets/fonts/ObjectSans-Medium.otf");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: ObjectSans;
  src: url("./assets/fonts/ObjectSans-Bold.otf");
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: Lato;
  src: url("./assets/fonts/Lato-Bold.ttf");
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: Lato;
  src: url("./assets/fonts/Lato-Regular.ttf");
  font-weight: 500;
  font-style: normal;
}

html,
body {
  margin: 0;
  background: $yellow;
}

html {
  overflow-x: hidden;
}

.modal-open {
  height: 100vh;
  overflow-y: hidden;
  padding-right: 15px;
}

#app {
  font-family: "ObjectSans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #231f20;
  display: flex;
  flex-direction: column;
  background: $yellow;
  min-height: 100vh;

  background: url("./assets/bg_Top.svg") no-repeat -100% 100px/65%,
    url("./assets/bg_Middle.svg") center 300px/120% no-repeat repeat,
    url("./assets/bg_Bottom.svg") -60px bottom/75% no-repeat $yellow;

  &.desktop {
    .banana-background {
      z-index: 0;
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: url("./assets/bg_banana_white.svg") center bottom/3200px no-repeat, url("./assets/bg_banana.svg") no-repeat top 500px left 0px/50%,
      url("./assets/bg_banana.svg") no-repeat top 130px right 0px/50% $yellow;
    }
  }

  .header {
    z-index: 1;
    background: $white;
  }

  .content {
    z-index: 1;
    flex: 1 0 auto;
  }

  .footer {
    flex-shrink: 0;
  }

  .push {
    height: 100%;
    flex: 1 0 auto;
  }

  &.TA {
    background: unset;
      background-color: #E6EEF0!important;
    .banana-background {
      background: unset;
      background-color: #E6EEF0!important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue